import React, {useContext} from 'react';
import {FiExternalLink, FiHelpCircle, FiHome, FiMenu} from 'react-icons/fi';
import {
  Flex,
  IconButton,
  Img,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuList
} from '@chakra-ui/react';
import {Link as GatsbyLink, graphql, useStaticQuery} from 'gatsby';
import {UserContext} from '../utils';
import {useGoogleLogout} from 'react-google-login';

export const UserButton = React.forwardRef((props, ref) => (
  <IconButton
    variant="ghost"
    rounded="full"
    fontSize="2xl"
    ref={ref}
    {...props}
  />
));

UserButton.displayName = 'UserButton';

export default function UserMenu() {
  const {user, client} = useContext(UserContext);

  const {config} = useStaticQuery(
    graphql`
      {
        config {
          googleClientId
        }
      }
    `
  );

  const {signOut, loaded} = useGoogleLogout({
    clientId: config.googleClientId,
    onLogoutSuccess: () => {
      localStorage.removeItem('playback:token');
      client.resetStore();
    }
  });

  return (
    <Menu>
      <MenuButton as={UserButton} icon={<FiMenu />} />
      <MenuList>
        <MenuGroup
          title={
            <Flex
              as="span"
              align="center"
              lineHeight="normal"
              fontWeight="medium"
            >
              <Img boxSize="5" mr="2" rounded="full" src={user.avatar} />
              {user.name}
            </Flex>
          }
        >
          <GatsbyLink to="/projects">
            <MenuItem>Projects</MenuItem>
          </GatsbyLink>
          <GatsbyLink to="/account">
            <MenuItem>My account</MenuItem>
          </GatsbyLink>
          <GatsbyLink to="/account#billing">
            <MenuItem>Billing settings</MenuItem>
          </GatsbyLink>
          <MenuItem isDisabled={!loaded} onClick={signOut}>
            Log out
          </MenuItem>
        </MenuGroup>
        <MenuDivider />
        <GatsbyLink to="/">
          <MenuItem icon={<FiHome />}>Back to home</MenuItem>
        </GatsbyLink>
        <GatsbyLink to="/guide">
          <MenuItem icon={<FiHelpCircle />}>How-to guide</MenuItem>
        </GatsbyLink>
        <MenuItem
          as="a"
          target="_blank"
          rel="noopener noreferrer"
          href={process.env.GATSBY_DISCORD_URL}
          icon={<FiExternalLink />}
        >
          Join the community
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
